import { api } from "@/api";

export const unlockAllLogins = async (): Promise<{ cleared: number }> => {
  const { data } = await api.client.post<{ cleared: number }>(
    "/monitor/login-security/unlock-all"
  );
  return data;
};
